module.exports = __webpack_public_path__ + "fonts/SFUIText-HeavyItalic.95ca63e7.eot";